module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay-header",
    class: [{
      right: _vm.theme === 'desktop'
    }, ("theme-" + _vm.theme)],
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "overlay-header-wrapper"
  }, [_c('div', {
    staticClass: "overlay-back-wrapper",
    on: {
      "click": _vm.closeOverlay
    }
  }, [(_vm.theme === 'desktop') ? _c('svg-icon-cancel', {
    staticClass: "overlay-back-btn",
    attrs: {
      "fill": "#FFF",
      "width": "32",
      "height": "32"
    }
  }) : _c('svg-icon-arrow-left', {
    staticClass: "overlay-back-btn",
    attrs: {
      "fill": "#FFF"
    }
  })], 1), _c('div', {
    staticClass: "overlay-header-meta"
  }, [(_vm.sections.length) ? _c('field-section', {
    staticClass: "overlay-header-section",
    attrs: {
      "sections": _vm.sections
    }
  }) : _vm._e(), _c('div', {
    staticClass: "overlay-header-title"
  }, [_vm._v(_vm._s(_vm.label))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a27b132","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/person/Header.vue
// module id = 1766
// module chunks = 1